import React from 'react'

export const Terms = () => {
  return (
    <div>Affiliate Terms and Conditions</div>
  )
}